export const userDropDownMenu = [
  { label: 'ログアウト', slug: 'logout' },
  { label: 'パスワード再設定', slug: 'changePassword' }
];
